import './mfe/initMfes';
import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { BaseProvider } from '@telus-uds/components-web'
import alliumTheme from '@telus-uds/theme-allium'

// Polyfill for React Native animation frame functions required by Skeleton component
if (typeof global !== 'undefined') {
  global.requestAnimationFrame = window.requestAnimationFrame.bind(window)
  global.cancelAnimationFrame = window.cancelAnimationFrame.bind(window)
}

createRoot(document.getElementById('root')!).render(
  <BaseProvider defaultTheme={alliumTheme as never}>
    <StrictMode>
      <App />
    </StrictMode>
  </BaseProvider>
)
